import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './ArticleGridSection.module.scss'
import ROUTES from '../../constants/routes'
import Container from '../container/Container'
import PostCard from "../post-card/PostCard"
import SwiperComponent from '../swiper/Swiper'

function ArticleGridSection ({ source }) {
  const postSections = source.map(( node, index) => {
    const { frontmatter, id, fields, timeToRead, excerpt } = node
    const { path, title, postimage, date, tag } = frontmatter

    // const tag =
    //   pageContext.tag ||
    //   tags.find(tag => tag.frontmatter.name === frontmatter?.tag)?.frontmatter
    //     ?.name
    const urlPath = path ? `${ROUTES.BLOG}${path}/` : fields.slug

    return (
      <PostCard
        className={styles[`card_${index}`]}
        key={id}
        title={title}
        path={urlPath}
        image={postimage?.childImageSharp?.gatsbyImageData}
        pubDate={date}
        timeToRead={timeToRead}
        tag={tag}
        excerpt={excerpt}
        alwaysShowReadMore
      />
    )
  })

  return (
    <Container>
      <div className={styles.content}>
        <SwiperComponent>{postSections}</SwiperComponent>
        <div className={styles.cardGrid}>
          {postSections}
        </div>
      </div>
    </Container>
  )
}

ArticleGridSection.propTypes = {
  source: PropTypes.array.isRequired,
}

export default ArticleGridSection;

